<template>
  <div style="width: 100%; cursor: pointer" ref="colorpicker">
    <div v-show="gradient == true">
      <label for="one" class="vc-type_color">
        <input type="radio" id="one" value="solid" v-model="type" class="vc-type_color">
        {{$t('ct-gradient-solid-color')}}
      </label>
      <br>
      <label for="two" class="vc-type_color">
        <input type="radio" id="two" value="gradient" v-model="type" class="vc-type_color">
        {{$t('ct-gradient-gradient-color')}}
      </label>
      <br>
    </div>
    <button class="btn btn-danger btn-remove-color" v-show="canRemove" v-on:click="removeColor">
      {{$t('ct-remove-color')}}
    </button>
    <div v-show="gradient == true && type=='gradient'">
      <label>{{$t('ct-primary-color')}}</label>
    </div>
    <div>
      <span id="cpicker0" class="current-color span-color"
            :style="'background-color: ' + colorValue1 + '; border: 1px solid lightgray;'"
            @click="togglePicker(0)"></span>
      <font-awesome-icon class="font-awesome-icon span-icon" :icon="['fas', 'tint']" @click="togglePicker(0)"/>
      <sketch-picker v-if="keyLogger" v-show="displayPicker" :color="colorValue" v-model="colorValuePicker"
                     @input="changeValue(0)"
                     :preset-colors="presets" ref="sketch"/>
    </div>

    <div v-show="gradient == true && type=='gradient'">
      <div><label>{{$t('ct-secondary-color')}}</label></div>
      <span id="cpicker2" class="current-color span-color"
            :style="'background-color: ' + colorValue2 + '; border: 1px solid lightgray;'"
            @click="togglePicker(2)"></span>
      <font-awesome-icon class="font-awesome-icon span-icon" :icon="['fas', 'tint']" @click="togglePicker(2)"/>
      <sketch-picker v-show="displayPicker2" :color="colorValue2" v-model="colorValuePicker2" @input="changeValue(2)"
                     :preset-colors="presets" ref="sketch2"/>
      <p class="alert-info text-center">
        {{$t('ct-gradient-incompatible-with-bg-image')}}
      </p>

    </div>
  </div>
</template>
<script>
  export default {
    name: 'ColorPickerComponent',
    data() {
      return {
        canRemove: false,
        gradient: false,
        type: 'solid',
        element: null,
        finalColor: '#FFFFFF',
        colorValue: '#FFFFFF',
        colorValuePicker: '#FFFFFF',
        colorValueToSave: '#FFFFFF',
        colorValue1: '#FFFFFF',
        colorValue2: '#FFFFFF',
        colorValuePicker1: '#FFFFFF',
        colorValuePicker2: '#FFFFFF',
        callback: null,
        displayPicker: false,
        displayPicker1: false,
        displayPicker2: false,
        returnRGBA: false,
        presets: [],
        keyLogger: true
      }
    },
    mounted() {
      this.$root.$on('toggleColorPicker', (value) => {
        this.togglePicker(value);
      });
      this.$root.$on('toggleColorPickerToSave', (value) => {
        this.colorValueToSave = value;
      });

    },
    methods: {
      removeColor() {
        this.type = 'solid';
        this.colorValuePicker = '#FFFFFF00';
        this.colorValue = '#FFFFFF00';
        this.$nextTick(() => {
          this.changeValue(0);
        });
      },
      togglePicker(id) {

        if (id == 0) {
          this.displayPicker = !this.displayPicker;
        }
        if (id == 2) {
          this.displayPicker2 = !this.displayPicker2;
        }

      },
      changeValue(id) {

        this.$nextTick(() => {

          let colorRec = this.colorValue.match(/(rgba\(\s*\d+,\s*\d+,\s*\d+,\s*(?:\d+|\d*\.\d+)\s*\)|#([0-9A-Fa-f]{6,8}))/);
          if(colorRec && colorRec[0]){
            this.colorValue = this.colorValue1 = colorRec[0];
          }

          if (id == 0) {
            if(typeof this.colorValuePicker.hex8 != 'undefined'){
              this.colorValue = this.colorValuePicker.hex8;
            }
          } else if (id == 2) {
            try {
                  this.colorValue2 = "rgba(" + Object.values(this.colorValuePicker2.rgba).join(',') + ")";
            } catch (e) {
              console.log(e)
            }
          }

          if (this.type === 'gradient') {
            this.colorValue1 = this.colorValue;
            this.colorValue = 'linear-gradient(90deg, ' + this.colorValue + ' 0%,' + this.colorValue2 + ' 100%)';
          } else if (this.type === 'solid') {
            if (this.returnRGBA) {
              this.colorValue = "rgba(" + Object.values(this.colorValuePicker.rgba).join(',') + ")";
            } else {
              this.colorValue = this.colorValue;
            }
          }
          this.callback(this.colorValue);

          this.$root.$emit('toggleColorPickerToSave', this.colorValue);

        });
      },
      getActualColor() {
        return this.colorValueToSave;
      },
      setValues(obj, returnRGBA) {

        if (typeof returnRGBA != 'undefined') {
          this.returnRGBA = returnRGBA;
        }


        const isColor = (strColor) => {
          const s = new Option().style;
          s.color = strColor;
          return s.color !== '';
        };

        let vm = this;

        this.gradient = false;
        this.gradient = obj.gradient;
        this.canRemove = obj.canRemove;


        if (obj.defaultValue && obj.defaultValue.indexOf('linear') !== -1) {

          // Get string between first ( and last )
          let str = obj.defaultValue.substring(obj.defaultValue.indexOf('(') + 1, obj.defaultValue.lastIndexOf(')'));
          // Finally with regex we can get each parts separatelly
          let objValues = str.split(/,(?![^(]*\))(?![^"']*["'](?:[^"']*["'][^"']*["'])*[^"']*$)/);

          this.colorValue = objValues[1].replace('0%', '');
          this.colorValue2 = objValues[2].replace('100%', '');

          this.type = 'gradient';
        } else {
          if (!isColor(obj.defaultValue) || obj.defaultValue === 'White') {
            obj.defaultValue = '#FFFFFF';
          }
          this.colorValue = this.colorValue1 = obj.defaultValue;
          this.colorValue2 = '#FFFFFF';
          this.type = 'solid';
        }

        this.colorValuePicker = this.colorValue;
        this.colorValuePicker2 = this.colorValue2;

        this.callback = obj.callback;

        if (
          localStorage.getItem('presetColors') !== '' &&
          localStorage.getItem('presetColors') !== null
        ) {
          this.presets = localStorage.getItem('presetColors').split(',');
        } else {
          this.presets = [];
        }

        // jquery, seu lindo
        if (this.$refs.colorpicker.querySelectorAll('#addColorToColorPicker').length === 0) {
          $(this.$refs.colorpicker).find('.vc-sketch-presets').prepend(
            '<button class="btn-add-color btn-outline-info" id="addColorToColorPicker">+</button>'
          );
          $(this.$refs.colorpicker).find('.btn-add-color').on('click', function (e) {

            e.preventDefault();
            e.stopPropagation();

            let colorActual = vm.getActualColor();


            if (!vm.presets.includes(colorActual) && colorActual.indexOf('linear') === -1) {
              vm.presets.push(colorActual);
              localStorage.setItem('presetColors', vm.presets);

              vm.$nextTick(() => {
                vm.addRemoveColor();

                $('.widget-focused').trigger('click');
              });
            } else {
              if (vm.presets.includes(colorActual)) {
                vm.$snotify.warning(vm.$t('ct-color-already-added'));
              }
              if (colorActual.indexOf('linear') !== -1) {
                vm.$snotify.warning(vm.$t('ct-color-linear-color-invalid'));
              }
            }
          });
        }
      },

      addRemoveColor() {
        let vm = this;

        $('.vc-sketch-presets-color').empty();

        $('.vc-sketch-presets-color').append(
          '<button class="close close-thik d-none">x</button>'
        );

        $('.vc-sketch-presets-color').hover(
          function () {
            $(this).children().removeClass('d-none');
          },
          function () {
            $(this).children().addClass('d-none');
          }
        );

        $('.close-thik').on('click', function (e) {
          e.stopPropagation();
          let colorRemoved = this.parentElement
            .getAttribute('aria-label')
            .substring(6);

          if (vm.presets.includes(colorRemoved)) {
            vm.presets.splice(vm.presets.indexOf(colorRemoved), 1);
            localStorage.setItem('presetColors', vm.presets);

            $('.widget-focused').trigger('click');
          }
        });
      }
    },

    watch: {
      displayPicker: function (newValue) {
        if (newValue) {
          this.addRemoveColor();
        }
      },
      type: function (newValue) {
        this.changeValue(0);
      },
    }
  };
</script>
<style lang="scss">

  .btn-remove-color {
    margin: 0 auto;
    text-align: center;
    width: 205px;
  }

  .span-color {
    cursor: pointer !important;
    background-color: rgb(255, 255, 255);
    border: 1px solid lightgray !important;
    width: 50px !important;
    display: inline-flex !important;
    height: 50px !important;
    border-radius: 0 !important;
  }

  .span-icon {
    display: inline-flex;
    width: 50px !important;
    height: 50px !important;
    padding: 10px;
    margin-top: -42px;
    margin-left: -5px;
    border: 1px solid lightgray;
    border-left: none;
    min-width: 50px  !important;;
  }

  .vc-sketch {
    width: unset !important;
    margin-bottom: 30px;
    box-shadow: none !important;
    border-radius: 0 !important;

    .vc-alpha-picker,
    .vc-hue-picker {
      background: black !important;
    }

    .btn-add-color {
      padding: 0;
      line-height: 0;
      border-radius: 3px;
      overflow: hidden;
      position: relative;
      display: inline-block;
      margin: 0 10px 10px 0;
      vertical-align: top;
      cursor: pointer;
      width: 16px;
      height: 16px;
      box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.15);
    }

    .close-thik {
      font: 11px arial;
      position: absolute;
      text-align: center;
      top: -10px;
      right: -8px;
      border: 1px solid #000;
      border-radius: 10px;
      background-color: #ffffff;
      opacity: 0.8;
    }

    .vc-sketch-presets-color {
      overflow: visible;
    }

    .btn-remove-color {
      font-size: 12px;
      padding: 1px;
      margin: 1px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/resources/Abstract/ColorPicker.vue